import { Panel } from "../../../../components/panels/Panel";
import { useErgonomicsContext } from "../../../../contexts/ErgonomicsContext";
import { saveLayoutData } from "../../../../services/ergonomics/ergonomics-service";
import { useEffect, useState } from "react";


export const ErgonomicsCardNotes = () => {

  const { layoutData, setLayoutData } = useErgonomicsContext();

  const [notes, setNotes] = useState(null);

  useEffect(() => {
    setNotes(layoutData.notes);
  }, [layoutData]);

  const handleOnChange = (e) => {
    setNotes(e.target.value);
  };

  const handleOnBlur = (e) => {
    const newLayoutData = { ...layoutData, notes: e.target.value };
    setLayoutData(newLayoutData);
    saveLayoutData(newLayoutData, true);
  }

  return (
    <Panel title="NOTES">
      <textarea
        value={notes || ''}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        className="bg-transparent outline-0 resize-none h-full placeholder-perception-gray-600"
        placeholder="Ajoutez vos observations, conclusions ou éléments de suivi..."
        spellCheck={false}
      />
    </Panel>
  );
};